export const sameValue = (left, right) => JSON.stringify(left) === JSON.stringify(right);

function mergeById(baseItems = [], localItems = [], remoteItems = [], conflicts, conflictLabel) {
  const base = new Map(baseItems.map((item) => [item.id, item]));
  const local = new Map(localItems.map((item) => [item.id, item]));
  const remote = new Map(remoteItems.map((item) => [item.id, item]));
  const merged = [];
  for (const itemId of new Set([...base.keys(), ...local.keys(), ...remote.keys()])) {
    const before = base.get(itemId), mine = local.get(itemId), theirs = remote.get(itemId);
    const mineChanged = !sameValue(mine, before), theirsChanged = !sameValue(theirs, before);
    let chosen;
    if (!mineChanged) chosen = theirs;
    else if (!theirsChanged || sameValue(mine, theirs)) chosen = mine;
    else { chosen = mine; conflicts.push(`${conflictLabel}:${itemId}`); }
    if (chosen) merged.push(chosen);
  }
  return merged;
}

export function mergeStoryDocument(base, local, remote) {
  const conflicts = [];
  const passages = mergeById(base?.passages, local?.passages, remote?.passages, conflicts, "passage");
  const variables = mergeById(base?.variables, local?.variables, remote?.variables, conflicts, "variable");
  const localStylesChanged = !sameValue(local?.styles, base?.styles), remoteStylesChanged = !sameValue(remote?.styles, base?.styles);
  let styles = remote?.styles || local?.styles || {};
  if (localStylesChanged && !remoteStylesChanged) styles = local.styles;
  else if (localStylesChanged && remoteStylesChanged && !sameValue(local.styles, remote.styles)) { styles = local.styles; conflicts.push("reader design"); }
  return { document: { ...remote, ...local, passages, variables, styles }, conflicts };
}
